import { createSelector } from 'reselect'

const getCorporateLogin = state => state.loginCorporate

export const getCorporateLoginData = createSelector(
  [getCorporateLogin],
  state => (state ? state.data : null)
)

export const getCorporateLoginError = createSelector(
  [getCorporateLogin],
  state => (state ? state.error : null)
)

export const isPostingCorporateLogin = createSelector(
  [getCorporateLogin],
  state => (state ? state.isFetching : false)
)

export const getCorporateLoginToken = createSelector(
  [getCorporateLoginData],
  data => (data ? data.access_token : null)
)

export const getCorporateLoginErrorDescription = createSelector(
  [getCorporateLoginError],
  error => (error && error.description && error.description[0] ? error.description[0] : null)
)
